<template>
  <div ref="container" class="mosaic-ctn">
    <div class="mosaic">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>
import MosaicMixin from './mosaic-mixin'
import { mapState } from 'vuex'

export default {
  name: 'MobileMosaicTransition',
  mixins: [MosaicMixin],
  computed: {
    ...mapState(['orientation']),
    isLandscapeScreen () {
      return this.orientation === 'landscape'
    }
  },
  methods: {
    assignAnimationVariables () {
      this.initialTransformOrigin = this.isLandscapeScreen ? 'left center' : 'center top'
      this.finalTransformOrigin = this.isLandscapeScreen ? 'right center' : 'center bottom'
      this.scaleProperty = this.isLandscapeScreen ? 'scaleX' : 'scaleY'
      this.stagger = 0.07
    }
  },
  mounted () {
    this.assignAnimationVariables()

    this.$root.$on('resize', () => {
      this.assignAnimationVariables()
    })
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .mosaic-ctn
    @apply fixed z-50 pin-t pin-l h-full w-full pointer-events-none

  .mosaic
    @apply w-full h-full
    display: grid
    grid-template-columns: repeat(12, 1fr)
    grid-template-rows: repeat(10, 1fr)
    @screen lg
      grid-template-columns: repeat(13, 1fr)
      grid-template-rows: repeat(8, 1fr)
    div
      @apply bg-white
      transform: scaleY(0)
      @screen sm-l
        transform: scaleX(0)
      &:nth-child(1)
        grid-column: 1 / 6
        grid-row: 1 / 6
      &:nth-child(2)
        grid-column: 6 / 8
        grid-row: 1 / 3
      &:nth-child(3)
        grid-column: 8 / 13
        grid-row: 1 / 3
      &:nth-child(4)
        grid-column: 6 / 9
        grid-row: 3 / 5
      &:nth-child(5)
        grid-column: 9 / 13
        grid-row: 3 / 5
      &:nth-child(6)
        grid-column: 6 / 13
        grid-row: 5 / 7
      &:nth-child(7)
        grid-column: 1 / 6
        grid-row: 6 / 7
      &:nth-child(8)
        grid-column: 1 / 9
        grid-row: 7 / 9
      &:nth-child(9)
        grid-column: 9 / 13
        grid-row: 7 / 9
      &:nth-child(10)
        grid-column: 1 / 13
        grid-row: 9 / 11
</style>
